import { navigate } from "gatsby";
import catchLinks from "./catch-links";
export const onClientEntry = function (_) {
  let pluginOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  catchLinks(window, pluginOptions, href => {
    navigate(href);
  });
};